import BankList from '@/pages/components/manage/dictionary/bank/BankList';

export default {
    list: BankList,
    recordRepresentation: 'nameEn',
};
